<template>
  <div class="virtual-tray-search col-12" :class="cols == 'sm-12' ? '':'col-sm-7'">
    <div class="input-group border border-light mb-3">
   
      <input
        v-model="searchtext"
        @input="updateSearchQuery"
        @keydown.enter="submitSearch"
        type="search"
        class="form-control border-0"
        placeholder="search by tray name"
      />
      <div class="input-group-prepend">
        <button
          tabindex="-1"
          type="submit"
          class="btn px-1"
          @click="submitSearch"
        >
          <Icon
          style="color: black;"
            icon="simple-line-icons:magnifier"
            :color="'#B6BBCF'"
            :width="'15'"
          />
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { Icon } from "@iconify/vue2";
import { mapActions,mapGetters } from "vuex";

export default {
  props:['cols'],
  data() {
    return {
      searchtext: "",
      timeout: null,
      
    };
  },
  computed:{
...mapGetters({
  selectedTab: "myTray/getselectedTabName",  

})
  },
  watch: {
    selectedTab: {
        handler: function () {
          this.searchtext = ""
        }
      }},
  methods: {
    ...mapActions({
      updateSearchInput: "myTray/updateSearchInput"
    }),
    updateSearchQuery(e) {
      if (this.timeout) clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.updateSearchInput(e.target.value);
      }, 1000);
    },

    submitSearch() {
      this.updateSearchInput(this.searchtext);
    }
  },
  components: {
    Icon
  }
};
</script>
